export default {"src":"/_next/static/media/british-airways-logo-mobile.ea13b023.svg","height":48,"width":200,"blurWidth":0,"blurHeight":0};